import * as angular from 'angular';

import { ComponentDefinition, DigitalSet, ObjectUser } from '@models/index';

class DigitalSetDeleteModalController implements angular.IComponentController {
    canDelete: boolean;

    readonly item: DigitalSet;
    readonly onDelete: ({ item: DigitalSet }) => void;
    readonly usages: ObjectUser[];

    static $inject = [];

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['usages'] && this.usages) {
            this.canDelete = !this.usages.length;
        }
    }

    deleteItem(item: DigitalSet) {
        this.onDelete({ item });
    }
}

export const wtDigitalSetDeleteModal: ComponentDefinition = {
    componentId: 'wtDigitalSetDeleteModal',
    controller: DigitalSetDeleteModalController,
    template: require('./digitalSetDeleteModal.component.html'),
    controllerAs: 'vm',
    bindings: {
        onDelete: '&',
        item: '<',
        usages: '<'
    }
};